<template>
    <div>
        <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="showDialog" width="800px"
            @close="setDialogClosed">
            <el-container direction="vertical">
                <el-row>
                    <el-descriptions :column="2" border style="margin-bottom: 10px">
                        <el-descriptions-item label="风险类型">指标报警</el-descriptions-item>
                        <el-descriptions-item label="操作">
                            <el-button type="primary" :disabled="consultationDialogVisible"
                                @click="consultationDetail">协诊</el-button>
                        </el-descriptions-item>
                    </el-descriptions>

                    <el-table v-loading="riskListLoading" :data="riskList" border fit highlight-current-row
                        style="width: 100%; margin-bottom: 30px" height="400">
                        <el-table-column width="450px" align="center" label="风险内容">
                            <template slot-scope="scope">
                                <span>{{ scope.row.msgContent }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column width="200px" align="center" label="时间">
                            <template slot-scope="scope">
                                <span>{{ getParsedTime(scope.row.createTime) }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column align="center" label="状态">
                            <template slot-scope="scope">
                                <span>{{ scope.row.codiagStatus }}</span>
                            </template>
                        </el-table-column>

                        <!-- <el-table-column label="操作" align="center" width="60">
                            <template slot-scope="scope">
                                <el-button style="margin-left: 0px; align-self: center" type="text"
                                    @click="complete(scope.row)">
                                    已读
                                </el-button>
                            </template>
                        </el-table-column> -->
                    </el-table>

                    <integrationCoDiagDialog v-if="integrationCoDiagDialogVisible" ref="integrationCoDiagDialogRef">
                    </integrationCoDiagDialog>

                    <codiagnosisModal v-if="codiagnosisModalVisible" ref="codiagnosisModalRef">
                    </codiagnosisModal>
                </el-row>
            </el-container>
        </el-dialog>
    </div>
</template>

<script>
import {
    getMessageWorkList
} from "@/api/health/integrationQuery";
import integrationCoDiagDialog from "./integrationCoDiagDialog.vue"
import codiagnosisModal from "../../components/codiagnosisModal/index.vue";
import moment from "moment";

export default {
    components: { integrationCoDiagDialog, codiagnosisModal },
    data() {
        return {
            codiagnosisModalVisible: false,
            consultationDialogVisible: false,
            integrationCoDiagDialogVisible: false,
            showDialog: false,
            title: "指标报警",
            dataContext: null,
            riskTotal: 0,
            riskListLoading: false,
            riskList: null,
            riskListQuery: {
                page: 1,
                pageSize: 10,
                refIdcard: null
            }
        };
    },
    methods: {
        // 编辑初始化页面内容
        async init(dataContext) {
            console.warn('this.dataContext:', dataContext);

            this.dataContext = dataContext;

            this.showDialog = true;

            // this.riskListQuery.refIdcard = dataContext.refIdcard;
            this.riskListQuery.refIdcard = dataContext.refIdcard || dataContext.idcard;

            // this.riskListQuery.idcard = dataContext.idcard;

            if (dataContext.isLung) {
                this.consultationDialogVisible = false;
            } else {
                this.consultationDialogVisible = dataContext.codiagStatus ? true : false;
            }
            this.consultationDialogVisible = false;

            this.$nextTick(() => {
                this.getRiskList();
            });
        },
        // 关闭对话框触发
        setDialogClosed() {
            this.showDialog = false;
        },
        getParsedTime(time) {
            return moment(time).format("YYYY-MM-DD HH:mm");
        },
        getRiskList() {
            this.riskListLoading = true;
            getMessageWorkList(this.riskListQuery).then((res) => {
                this.riskListLoading = false;
                if (res.msg == "success") {
                    this.riskTotal = res.data.total;
                    this.riskList = res.data.records;
                }
            }).catch(error => {
                console.log(error);
            });
        },
        // 跳转协诊详情
        consultationDetail() {
            if (this.dataContext.isLung) {
                this.codiagnosisModalVisible = true;
                this.$nextTick(() => {
                    this.$refs['codiagnosisModalRef'].init(this.dataContext);
                })
                return;
            }

            this.integrationCoDiagDialogVisible = true;

            this.$nextTick(() => {
                this.$refs['integrationCoDiagDialogRef'].init(this.dataContext);
            })
        },
        complete(data) {

        },
        getParsedTime(time) {
            return moment(time).format("YYYY-MM-DD HH:mm");
        }
    },
};
</script>

<style lang="less" scoped></style>